export default __webpack_public_path__ + "static/media/kinder7.05601667.png";